import { IIdentityAuth0Config, IIdentityLinksConfig,
    IIdentityLogoConfig, IIdentityNavigaConfig, IIdentityProviderConfig,
    ISophiPaywallOffer, ISubscriberProviderConfig } from '../../../services/identity/adapters/adapter'
import { Entity } from '../../entity'

export interface IIdentityConfiguration {
    sso?: IIdentityProviderConfig
    subscriber?: ISubscriberProviderConfig
    gnsOptions?: IGnsOptionsConfig
}

export interface IGnsOptionsConfig {
    offerId: string
    templateId: string
}

export interface IMicrosoftLoginConfig {
    id: string
}

export interface IExclusiveNewsletterConfig {
    listId: string
    resId: string
}

export class IdentityConfiguration extends Entity implements IIdentityConfiguration {
    public logo?: IIdentityLogoConfig
    public links?: IIdentityLinksConfig
    public property?: string
    public sso?: IIdentityProviderConfig
    public subscriber?: ISubscriberProviderConfig
    public showPasswordPolicy?: boolean
    public gnsOptions?: IGnsOptionsConfig
    public microsoftLogin?: IMicrosoftLoginConfig
    public showNewsletterOptIn?: boolean
    public sophiPaywallOffer?: ISophiPaywallOffer
    public useSophiDecision?: boolean
    public showOnboardPages?: boolean
    public exclusiveNewsletter?: IExclusiveNewsletterConfig
    public auth0?: IIdentityAuth0Config
    public naviga?: IIdentityNavigaConfig

    public fromJson(jsonObject: object): IIdentityConfiguration {
        super.fromJson(jsonObject)

        // parse provider objects
        if ((jsonObject as this).links) {
            this.links = (jsonObject as this).links
        }
        if ((jsonObject as this).sso) {
            this.sso = (jsonObject as this).sso
        }
        if ((jsonObject as this).subscriber) {
            this.subscriber = (jsonObject as this).subscriber
        }
        if ((jsonObject as this).gnsOptions) {
            this.gnsOptions = (jsonObject as this).gnsOptions
        }
        if ((jsonObject as this).logo) {
            this.logo = (jsonObject as this).logo
        }
        if ((jsonObject as this).microsoftLogin) {
            this.microsoftLogin = (jsonObject as this).microsoftLogin
        }
        if ((jsonObject as this).showNewsletterOptIn) {
            this.showNewsletterOptIn = (jsonObject as this).showNewsletterOptIn
        }
        if ((jsonObject as this).sophiPaywallOffer) {
            this.sophiPaywallOffer = (jsonObject as this).sophiPaywallOffer
        }
        if ((jsonObject as this).useSophiDecision) {
            this.useSophiDecision = (jsonObject as this).useSophiDecision
        }
        if ((jsonObject as this).showOnboardPages) {
            this.showOnboardPages = (jsonObject as this).showOnboardPages
        }
        if ((jsonObject as this).exclusiveNewsletter) {
            this.exclusiveNewsletter = (jsonObject as this).exclusiveNewsletter
        }
        if ((jsonObject as this).auth0) {
            this.auth0 = (jsonObject as this).auth0
        }
        if ((jsonObject as this).naviga) {
            this.naviga = (jsonObject as this).naviga
        }

        return this
    }
}
